import axios from 'axios';

import config from '@/config';

const { iffApi } = config.ctx;

/**

 * 工作报告 API 服务

 */

export const workReportService = {

  /** 创建或更新草稿（uuid 非空时为更新） */

  save: (data) => axios.post(`${iffApi}/work-report/save`, data),

  /** 预览 Word（二进制流，不改变草稿状态） */

  previewReportFile: (id) => axios.get(`${iffApi}/work-report/preview/${id}`, { responseType: 'blob' }),

  /** 归档锁定 */

  archive: (id) => axios.post(`${iffApi}/work-report/archive/${id}`),

  /** 下载已归档的 Word 文档（返回文件流） */

  getReportFile: (id) => axios.get(`${iffApi}/work-report/getReportFile/${id}`, { responseType: 'blob' }),

  /** 分页查询报告列表 */

  queryPage: (params = {}) => axios.get(`${iffApi}/work-report/page`, { params }),

  getDetail: (id) => axios.get(`${iffApi}/work-report/detail/${id}`),

  /** 逻辑删除报告 */

  delete: (id) => axios.delete(`${iffApi}/work-report/${id}`)

};
